export const mediaBaseURL = process.env.REACT_APP_MEDIA_BASE_URL;